import React, {Component} from 'react';
import MockupEditor from "../MockupEditor";

import "./style.css";

const dummy_mockup = {"active":true,"description":"Portrait Frame With Lights Mockup With Changeable Background Color.","keywords":"frame, portrait frame, frame on a wall","layers":[{"features":{"hue":true},"camera_position":{"x":0,"y":0,"z":0},"camera_target":{"x":0,"y":0,"z":0},"upload_resolution":{"height":800,"width":1200},"position":{"x":0,"y":0},"type":"static","active":false,"image_src":"uploads/mockup_resources/5c6ed6d6bfea3168e474ebec/5c6ed6e5bfea3168e474ebed/daa9f6c1e0e72e5ec2b1db7226b1c3d4.png","image_src_medium":"uploads/mockup_resources/5c6ed6d6bfea3168e474ebec/5c6ed6e5bfea3168e474ebed/daa9f6c1e0e72e5ec2b1db7226b1c3d4_medium.png","opacity":1,"blend_alpha":0,"width":100,"height":100,"_id":"5c6ed6e5bfea3168e474ebed","mockup":"5c6ed6d6bfea3168e474ebec","layer_index":0,"name":"Background","createdAt":"2019-02-21T16:50:45.148Z","updatedAt":"2019-12-18T22:28:22.654Z","__v":0},{"features":{"hue":false},"camera_position":{"x":0,"y":0,"z":10919.6},"camera_target":{"x":0,"y":0,"z":0},"upload_resolution":{"height":4431,"width":3472},"position":{"x":32.60161254179715,"y":24.922535246433345},"type":"dynamic","active":false,"image_src":"https://www.w3schools.com/w3css/img_lights.jpg","image_src_medium":null,"opacity":1,"blend_alpha":0,"width":34.7481963244666,"height":59.006884161302615,"_id":"5c6ed708bfea3168e474ebee","mockup":"5c6ed6d6bfea3168e474ebec","layer_index":2,"name":"Frame","createdAt":"2019-02-21T16:51:20.866Z","updatedAt":"2019-12-18T22:28:22.657Z","__v":0,"obj_src":"uploads/mockup_resources/5c6ed6d6bfea3168e474ebec/5c6ed708bfea3168e474ebee/cfff6b588f4ddf6888730de30ff30158.obj","mtl_src":"uploads/mockup_resources/5c6ed6d6bfea3168e474ebec/5c6ed708bfea3168e474ebee/288eae01b5cf764f5e709b0a33d65511.mtl"},{"features":{"hue":false},"camera_position":{"x":0,"y":0,"z":0},"camera_target":{"x":0,"y":0,"z":0},"upload_resolution":{"height":800,"width":1200},"position":{"x":0,"y":0},"type":"static","active":false,"image_src":"uploads/mockup_resources/5c6ed6d6bfea3168e474ebec/5c80085a5f02ff65de436d02/670cc6e1d1ad9767ad67aa8fe6d9e0a3.png","image_src_medium":"uploads/mockup_resources/5c6ed6d6bfea3168e474ebec/5c80085a5f02ff65de436d02/670cc6e1d1ad9767ad67aa8fe6d9e0a3_medium.png","opacity":1,"blend_alpha":0,"width":100,"height":100,"_id":"5c80085a5f02ff65de436d02","mockup":"5c6ed6d6bfea3168e474ebec","layer_index":1,"name":"Layer 2","createdAt":"2019-03-06T17:50:18.578Z","updatedAt":"2019-12-18T22:28:23.321Z","__v":0}],"tracing_image_src":"uploads/mockup_resources/5c6ed6d6bfea3168e474ebec/28ec016748e950c601fae370f939a20f.jpg","categories":["5c7932d05e5d602f6e488cb0"],"price":8,"placeholders":["uploads/mockup_resources/5c6ed6d6bfea3168e474ebec/10072488726648673487.jpg"],"priority":3,"_id":"5c6ed6d6bfea3168e474ebec","name":"Portrait Frame With Light","height":1774,"width":2365,"createdAt":"2019-02-21T16:50:30.306Z","updatedAt":"2020-01-15T05:55:43.213Z","__v":2,"asset_id":"17690008_l"}

class MockupEditorPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mockup: false,
            saved_mockup: false
        };
    }

    set_state = async state => new Promise(resolve => this.setState(state, resolve));

    isValidInput = (inp, min, max) => {
        if (inp === "") return true;
        let val = parseFloat(inp);
        return (!isNaN(val) && val >= min && val <= max);
    };

    updateFields = function(value){
        var updates = {}
        for(var key in value){
            if(this.state[key] != undefined){
                updates[key] = value[key]
            }
        }

        return this.set_state(updates)
    }

    handleFiltersOnChange = (event) => {
        var min = -100
        var max = 100
        if(event.target.name === 'vignette') {
            min = 0
        }

        if (this.isValidInput(event.target.value, min, max)) {
            this.set_state({[event.target.name]: event.target.value});
            var value = {}
            value[[event.target.name]] = Number(event.target.value);
            this.props.apply_mockup_editor(value);
        }
    };

    render() {
        return (
            <div>
                {this.state.mockup?(<MockupEditor
                    mockup={this.state.mockup}
                    saved_mockup={this.state.saved_mockup}
                    device_type={'tablet'}
                    fetch_all_saved_mockups={() => {}}
                    user={this.props.user}
                    is_dm={true}
                    apply_mockup_editor={this.props.apply_mockup_editor}
                />):''}
            </div>
        );
    }
}

export default MockupEditorPanel;